/**
 * @author kper6454
 * */
import initialState from './initialState';
import {
  CLEAR_ITEM_PRICE_FILTER,
  CLEAR_MODULE_VIEW_FILTER,
  RECEIVE_MODULE_GROUP_DELETE,
  UPDATE_ITEM_PRICE_FILTER,
  UPDATE_MODULE_VIEW_FILTER,
} from '../actions/costMaintenanceActions';

const filterDataInitialState = initialState.priceModule.filterData;
export default function priceModuleFilterReducer(state, { type, data }) {
  if (typeof state === 'undefined') {
    return filterDataInitialState;
  }

  if (type === UPDATE_ITEM_PRICE_FILTER) {
    return { ...state, itemPrice: { [data.key]: data.value } };
  }

  if (type === CLEAR_ITEM_PRICE_FILTER) {
    return { ...state, itemPrice: filterDataInitialState.itemPrice };
  }

  if (type === UPDATE_MODULE_VIEW_FILTER) {
    return { ...state, moduleView: { [data.key]: data.value } };
  }

  if (type === CLEAR_MODULE_VIEW_FILTER) {
    return { ...state, moduleView: filterDataInitialState.itemPrice };
  }

  if (type === RECEIVE_MODULE_GROUP_DELETE) {
    return {
      ...state,
      moduleView: {
        selectedModules: state.moduleView.selectedModules.filter(
          (module) => module.value.module_id !== data,
        ),
      },
    };
  }

  return state;
}
